export default {"src":"/_next/static/media/ValidityActive.d999ebfe.svg","height":22,"width":25,"blurWidth":0,"blurHeight":0};